module.exports = __webpack_public_path__ + "static/media/GMA-S2100-4AER_OR03_sideview_right.7a6ffcff.jpg";